module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#olympic",
      toString: function () {
        return this.url;
      }
    }